import { ContainerClient } from "@azure/storage-blob";
import * as React from 'react';
import { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Col, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { dabFilmsAction } from '../../actions/dabFilmsAction';
import { videoHotlineAction } from '../../actions/videoHotlineAction';
import { DABBackToList, DABButton, DABTextBox, LoadingSpinnerModal } from '../../components/dab';
import DABFilmsService from '../../services/api/dabFilmsService';
import { getLoggedUserId } from '../../services/selectors/Accounts';
import { showAlert, showAlertWithBacktrack } from "../common/functions";

let containerClient: any = null;
let sasTokenExpiry: any = null;
const getSasToken = async () => {
	try {
		const response: any = await DABFilmsService.dabFilmsGenerateSASToken();
		const { sasUrl, expiresOn } = response;
		sasTokenExpiry = new Date(expiresOn);
		return sasUrl;
	} catch (err) {
		console.error("Error fetching SAS token:", err);
		throw new Error("Unable to fetch SAS token.");
	}
};
async function initializeContainerClient() {
	const containerSasUrl = await getSasToken();
	containerClient = new ContainerClient(containerSasUrl);
}
interface DABFilmsProps {
  dispatch: Dispatch<any>;
  dabFilmsData: any;
  videoHotlineData: any;
  callback: any;
  id: number;
}

const DABFilmsDetail: React.SFC<DABFilmsProps> = ({
  dispatch, dabFilmsData, videoHotlineData, callback, id }) => {
  const history = useHistory();

  let anyVa: any;

  const [formSubmit, setFormSubmit] = useState(false);
  const [isBookMark, setIssBookMark] = useState(false);
  const [isReviewPage, setIsReviewPage] = useState(false);
  const [isErrorOnPage, setIsErrorOnPage] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [fileSelected, setFileSelected] = useState(anyVa);
  const [isDetailLoaded, setDetailLoaded] = useState(false);
  const [isDirty, setIsDirty] = useState<boolean>(false)
  const [videoTitle, setVideoTitle] = useState("");
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
	const [uploadedVideoURL, setUploadedVideoURL] = useState('');
	const [isUploadLoading, setUploadLoading] = useState(false);
	const [isUploadingFile, setUploading] = useState(false);
	const [newFileSelected, isNewFileSelected] = useState(anyVa);
	const [uploadFileMsg, setUploadFileMsg] = useState<any>(null);

  React.useEffect(() => {
    const frompath = sessionStorage.getItem('fromPath')
    if (frompath) {
      sessionStorage.removeItem('fromPath')
    }
    if (!videoHotlineData?.message?.messageBoardId) {
      dispatch(videoHotlineAction.getMessageBoardID('dab-films'));
    }
    if (id !== 0) {
      dispatch(dabFilmsAction.dabFilmsGetDetail(id));
      setShowModal(true);
    }
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileFormat = file.name.split(".").pop().toLowerCase();
    const allowedVideoFormats = ["mp4"];

    if (allowedVideoFormats.includes(fileFormat)) {
      setFileSelected(file);
			isNewFileSelected(true);
      setSelectedFileName(file.name);
    } else {
      event.target.value = "";
      showAlert("Please select an MP4 video file only.", true);
      return;
    }
    setIsDirty(true);
  };

  if (dabFilmsData) {
    if (dabFilmsData.isError && !dabFilmsData.isSuccess) {
      if (showModal) {
        setShowModal(false);
      }
      dabFilmsData.isError = false;
      if (dabFilmsData.status === 'Unauthorized') {
        sessionStorage.setItem('fromPath', window.location.pathname + window.location.search)
        history.push("/401");
      } else {
        showAlertWithBacktrack(dabFilmsData.status, true, history);
      }
      setIsErrorOnPage(false);
    }

    if (!dabFilmsData.isError && dabFilmsData.isSuccess) {
      if (showModal) {
        setShowModal(false);
      }
    }

    // GET DETAIL HANDLE 
    if (dabFilmsData.isDetailComplete) {
      if (!isDetailLoaded && dabFilmsData.dabFilmsInput?.dabFilm) {
        if (dabFilmsData.dabFilmsInput?.dabFilm !== null) {
          const fileName = dabFilmsData.dabFilmsInput?.dabFilm?.messageAttachments?.[0]?.uploadedFileUrl?.split('/').pop();
          setVideoTitle(dabFilmsData.dabFilmsInput?.dabFilm?.subject);
          setSelectedFileName(fileName);
          setIsFileUploaded(true);
          setDetailLoaded(true);

          dabFilmsData.isSuccess = false;
          dabFilmsData.status = null;
        }
      }
    }

    // EXECUTE AFTER SUCCESSFULL SUBMIT
    if (showModal && formSubmit && !dabFilmsData.isFormSubmit && dabFilmsData.isSuccess) {
      if (dabFilmsData.isSuccess) {
        if (showModal) {
          setShowModal(false);
        }
        window.localStorage.setItem('alertMessage', dabFilmsData.status);
        window.location.href = "/dabfilms";
      }
    }

    //   if (dabFilmsData.isDetailComplete) {
    //     if (!isDetailLoaded && dabFilmsData.dabFilmssInput) {
    //        callback(dabFilmsData.dabFilmsInput.title);
    //        // setIsDetailLoaded(true);
    //     }
    //     if (showModal) {
    //        setShowModal(false);
    //     }
    //  }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if(!isFileUploaded) {
      return setUploadFileMsg("Please upload a video file before submitting.");
    } else {
      setUploadFileMsg(null);
    }
    setShowModal(true);
    sessionStorage.removeItem("createDABFilms")
    const data = {
      message: videoTitle,
      videoFileUrl: uploadedVideoURL ? uploadedVideoURL?.split('?')?.[0] : '',
      authorUserId: getLoggedUserId(),
      messageBoardID: videoHotlineData?.message?.messageBoardId
    }
    setFormSubmit(true);
    dispatch(dabFilmsAction.dabFilmsSave(id, data));
  };

  React.useEffect(() => {
    const eventHandler = (event: BeforeUnloadEvent) => {
      var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
      const inSession = Date.now() < Number(sessionExpiry)
      if (!formSubmit && inSession) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
    return () => { window.removeEventListener("beforeunload", eventHandler) };
  }, [isDirty && !formSubmit])

  const handleCancel = (e) => {
    e.preventDefault();
    history.goBack();
  }

  const uploadToAzure = async (file: File): Promise<string> => {
		setUploadLoading(true);
		if (!containerClient || new Date() > sasTokenExpiry) {
			await initializeContainerClient();
		}

		const fileName = file.name.split(/[/\\]/).pop()!;
		const blobClient = containerClient!.getBlockBlobClient(fileName);

		try {
			const t0 = performance.now();

			await blobClient.uploadBrowserData(file, {
				blobHTTPHeaders: {
					blobContentType: file.type,
					blobCacheControl: "public, max-age=31536000, immutable",
				},
				blockSize: 4 * 1024 * 1024,
				concurrency: 5,
				onProgress: (ev) => console.log("Uploaded bytes:", ev.loadedBytes),
			});

			setUploadedVideoURL(blobClient.url);
			return blobClient.url;
		} catch (error: any) {
			if (error.statusCode === 403 || error.statusCode === 401) {
				console.warn("SAS token expired, retrying...");
				await initializeContainerClient();

				const retryBlobClient = containerClient!.getBlockBlobClient(fileName);
				await retryBlobClient.uploadBrowserData(file, {
					blobHTTPHeaders: {
						blobContentType: file.type,
						blobCacheControl: "public, max-age=31536000, immutable",
					},
					blockSize: 4 * 1024 * 1024,
					concurrency: 5,
					onProgress: (ev) => console.log("Uploaded bytes:", ev.loadedBytes),
				});

				setUploadedVideoURL(retryBlobClient.url);
				return retryBlobClient.url;
			}

			console.error("Upload failed:", error);
			alert("Upload failed. See console for details.");
			throw error;
		} finally {
			setUploadLoading(false);
		}
	};

  const handleUpload = async (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (!fileSelected) return alert("Please select a file.");
		setUploading(true);
    setUploadFileMsg(null);
		await uploadToAzure(fileSelected);
		setUploading(false);
		isNewFileSelected(false);
		setIsFileUploaded(true);
	};

  return (
    <>
      <div className="dabfilms-detail mb-5">
        {showModal && (<LoadingSpinnerModal isShowModal={showModal} modalChange={() => { }} />)}
        <div className='card-box m-0'>
          {!isBookMark && !isReviewPage && !isDetailLoaded && (id === 0) && (
            <form name="createform" onSubmit={handleSubmit} className="create-form">
              <div className="row">
                <div className="col-6">
                  <FormGroup>
                    <Label htmlFor="videoName" className="col-form-label" data-testid="videoName">Title</Label>
                    <DABTextBox type="text" id="title" data-testid="title" isRequired={true} isHover={false}
                      onChange={(event) => { setVideoTitle(event.target.value) }}
                      value={videoTitle}
                      pattern=".*\S.*"
											title="Input cannot be only spaces"
                      maxLength={100} />
                      {videoTitle?.length>=100 && (
												<span className="text-warning">
													Character limit met. Maximum 100 characters allowed	
												</span>
											)}
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col-6 mb-2">
                  <FormGroup data-testid="videoFileContainer">
                    <Label
                      data-testid="lblVideoFileCreate"
                      htmlFor="videoFile"
                      className="col-form-label"
                    >
                      Video File
                    </Label>
                    <Input
                      type="file"
                      name="videoFileUpload"
                      id="videoFile"
                      accept=".mp4"
                      required={!fileSelected && !selectedFileName}
                      onChange={(e) => handleFileChange(e)}
                    />
                  </FormGroup>
                  <small className="text-muted d-block mb-1">
                    Allowed file type: MP4 only
                  </small>
                  {selectedFileName && (
                    <div className="mb-1 text-muted">
                      Selected file: <strong>{selectedFileName}</strong>
                    </div>
                  )}
                  <div className="d-flex align-items-center gap-3 action-btn" data-testid="uploadVideobtn">
											<DABButton id="upload" className={`btn-submit-frm ${(newFileSelected && !isUploadingFile) ? "" : "disabled"}`} onClick={handleUpload} value="Upload File">
												Upload File
											</DABButton>
											{isUploadingFile && <><span>Uploading...</span><Spinner size="sm"></Spinner></>}
									</div>
                  {uploadFileMsg && (
                    <span className="text-warning">
                      {uploadFileMsg}
                    </span>
									)}
                </div>
              </div>
              <Row className="bd-buttons mt-3">
                <Col lg='5' data-testid="cancelButtonContainer">
                  <DABButton id="backToCreate" className={`${isUploadingFile ? 'disabled' : ''}`} onClick={handleCancel} value="CANCEL">
                    CANCEL
                  </DABButton>
                </Col>

                <Col lg='1' data-testid="createButtonContainer">
                  <DABButton id="submit" className={`btn-submit-frm ${isUploadingFile ? 'disabled' : ''}`} value="CREATE">
                    Create
                  </DABButton>
                </Col>
              </Row>
            </form>
          )}

          {isDetailLoaded && !isBookMark && !isReviewPage && (
            <>
							<DABBackToList onClick={(e) => { history.goBack(); }} />
            <form name="createform" onSubmit={handleSubmit} className="create-form">
              <div className="row">
                <div className="col-6">
                  <FormGroup>
                    <Label htmlFor="videoName" className="col-form-label" data-testid="videoName">Title</Label>
                    <DABTextBox type="text" id="title" data-testid="title" isRequired={true} isHover={false}
                      onChange={(event) => { setVideoTitle(event.target.value) }}
                      value={videoTitle}
                      pattern=".*\S.*"
											title="Input cannot be only spaces"
                      maxLength={100} />
                      {videoTitle?.length>=100 && (
												<span className="text-warning">
													Character limit met. Maximum 100 characters allowed	
												</span>
											)}
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col-6 mb-2">
                  <FormGroup data-testid="videoFileContainer">
                    <Label
                      data-testid="lblVideoFileCreate"
                      htmlFor="videoFile"
                      className="col-form-label"
                    >
                      Video File
                    </Label>
                    <Input
                      type="file"
                      name="videoFileUpload"
                      id="videoFile"
                      accept=".mp4"
                      required={!fileSelected && !selectedFileName}
                      onChange={(e) => handleFileChange(e)}
                    />
                  </FormGroup>
                  <small className="text-muted d-block mb-1">
                    Allowed file type: MP4 only
                  </small>
                  {selectedFileName && (
                    <div className="mb-1 text-muted">
                      Selected file: <strong>{selectedFileName}</strong>
                    </div>
                  )}
                  <div className="d-flex align-items-center gap-3 action-btn" data-testid="uploadVideobtn">
											<DABButton id="upload" className={`btn-submit-frm ${(newFileSelected && !isUploadingFile) ? "" : "disabled"}`} onClick={handleUpload} value="Upload File">
												Upload File
											</DABButton>
											{isUploadingFile && <><span>Uploading...</span><Spinner size="sm"></Spinner></>}
									</div>
                  {uploadFileMsg && (
                    <span className="text-warning">
                      {uploadFileMsg}
                    </span>
									)}
                </div>
              </div>
              <Row className="bd-buttons mt-3">
                <Col lg='5' data-testid="cancelButtonContainer">
                  <DABButton id="backToCreate" className={`${isUploadingFile ? 'disabled' : ''}`} onClick={handleCancel} value="CANCEL">
                    CANCEL
                  </DABButton>
                </Col>

                <Col lg='1' data-testid="saveButtonContainer">
                  <DABButton id="submit" className={`btn-submit-frm ${isUploadingFile ? 'disabled' : ''}`} value="SAVE">
                    Save
                  </DABButton>
                </Col>
              </Row>
            </form>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  const { dabFilmsData, videoHotlineData } = state;
  return {
    dabFilmsData,
    videoHotlineData
  };
};

export default connect(mapStateToProps)(DABFilmsDetail);